import React, { useEffect, useState } from 'react'

/**
 * Smart install prompt.
 * - Android/Chrome: captures beforeinstallprompt → one-tap "Add to Home Screen"
 * - iOS Safari: shows the Share → Add to Home Screen instructions
 * - Already installed (standalone): shows nothing
 */
export default function InstallPrompt() {
  const [deferred, setDeferred] = useState<any>(null)
  const [show, setShow] = useState(false)
  const [isIOS, setIsIOS] = useState(false)

  useEffect(() => {
    const ua = navigator.userAgent
    const ios = /iphone|ipad|ipod/i.test(ua)
    const standalone =
      (navigator as any).standalone === true ||
      window.matchMedia('(display-mode: standalone)').matches
    if (standalone) return // already installed — nothing to do
    if (localStorage.getItem('tingl_install_dismissed')) return

    setIsIOS(ios)

    // Android / desktop Chrome: capture the install event
    const handler = (e: Event) => {
      e.preventDefault()
      setDeferred(e)
      setShow(true)
    }
    window.addEventListener('beforeinstallprompt', handler)

    // iOS never fires that event — show manual instructions after a beat
    if (ios) {
      const t = setTimeout(() => setShow(true), 2500)
      return () => { clearTimeout(t); window.removeEventListener('beforeinstallprompt', handler) }
    }
    return () => window.removeEventListener('beforeinstallprompt', handler)
  }, [])

  const install = async () => {
    if (!deferred) return
    deferred.prompt()
    await deferred.userChoice
    setDeferred(null)
    setShow(false)
  }

  const dismiss = () => {
    localStorage.setItem('tingl_install_dismissed', '1')
    setShow(false)
  }

  if (!show) return null

  return (
    <div className="fade-in" style={{
      position: 'fixed', left: 12, right: 12, bottom: 'calc(14px + env(safe-area-inset-bottom))',
      zIndex: 400, maxWidth: 420, margin: '0 auto',
      background: 'rgba(16,16,16,0.96)', backdropFilter: 'blur(20px)',
      border: '1px solid rgba(0,255,209,0.3)', borderRadius: 22,
      padding: '16px 18px', boxShadow: '0 12px 40px rgba(0,0,0,0.5)',
    }}>
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
        <div style={{
          width: 40, height: 40, borderRadius: 12, flexShrink: 0,
          background: 'radial-gradient(circle at 35% 32%, #ffffffcc 0%, #00FFD1 40%, transparent 100%)',
          boxShadow: '0 0 18px #00FFD166',
        }} />
        <div style={{ flex: 1, minWidth: 0 }}>
          <div className="syne" style={{ fontWeight: 800, fontSize: 15, letterSpacing: '-0.02em', marginBottom: 3 }}>
            Add tingl to your home screen
          </div>
          {isIOS ? (
            <div style={{ fontSize: 12.5, color: 'rgba(255,255,255,0.7)', lineHeight: 1.5 }}>
              Tap <strong style={{ color: '#00FFD1' }}>Share</strong> <span style={{ fontSize: 14 }}>􀈂</span> below, then <strong style={{ color: '#00FFD1' }}>“Add to Home Screen.”</strong> Open tingl from the icon to feel tingls on your lock screen.
            </div>
          ) : (
            <div style={{ fontSize: 12.5, color: 'rgba(255,255,255,0.7)', lineHeight: 1.5 }}>
              Install tingl for lock-screen feelings and instant open — no app store needed.
            </div>
          )}
        </div>
        <button onClick={dismiss} style={{
          background: 'none', border: 'none', color: 'rgba(255,255,255,0.4)',
          fontSize: 16, cursor: 'pointer', flexShrink: 0, padding: 2,
        }}>✕</button>
      </div>

      {!isIOS && deferred && (
        <button className="pill grad" style={{ marginTop: 12, padding: '12px' }} onClick={install}>
          Add to home screen
        </button>
      )}
    </div>
  )
}
